// extracted by mini-css-extract-plugin
module.exports = {"root":"AreenaLink_root__9ZJp7","logo":"AreenaLink_logo__60Tl9"};